/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 */
import type { Dictionary, Props } from './../types/types';

import React from 'react';

const textWrap = (props: Props) => {
   if (props.h1) return <h1 style={props.innerStyle}>{props.children}</h1>;
   if (props.h2) return <h2 style={props.innerStyle}>{props.children}</h2>;
   if (props.h3) return <h3 style={props.innerStyle}>{props.children}</h3>;
   if (props.h4) return <h4 style={props.innerStyle}>{props.children}</h4>;
   if (props.h5) return <h5 style={props.innerStyle}>{props.children}</h5>;
   if (props.h5) return <h5 style={props.innerStyle}>{props.children}</h5>;

   if (props.small) {
      return <small>{props.children}</small>;
   }

   return props.children;
};

const Text = (props: Props) => {
   if (!props) props = {};
   props = {
      className: 'text',
      innerStyle: null,
      children: null,
      style: null,
      numberOfLines: null,
      h1: null,
      h2: null,
      h3: null,
      h4: null,
      h5: null,
      h6: null,
      small: null,
      ...props
   };

   let singleLine: Dictionary | null = null;

   if (props.numberOfLines && props.numberOfLines == 1) {
      singleLine = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
   }

   return (
      <div className={props.className} style={{ ...props.style, lineHeight: props.style && props.style.lineHeight ? props.style.lineHeight + 'px' : null, ...singleLine }}>
         {textWrap(props)}
      </div>
   );
};

export default React.memo(Text);
